import { AppEnv } from '../types/app-env'

const preprod = {
	apiKey: 'AIzaSyCD9OK-UT1cb3PE3-i0V7S0RqJpqX5XbHg',
	authDomain: 'cocoon-space-preprod-mobile.firebaseapp.com',
	databaseURL:
		'https://cocoon-space-preprod-mobile-default-rtdb.europe-west1.firebasedatabase.app',
	projectId: 'cocoon-space-preprod-mobile',
	storageBucket: 'cocoon-space-preprod-mobile.firebasestorage.app',
	messagingSenderId: '283339168852',
	appId: '1:283339168852:web:73557ef00ff029d1baa1c1',
	measurementId: 'G-9NN0TJCQQN',
} as const

const prod = {
	apiKey: 'AIzaSyCD9OK-UT1cb3PE3-i0V7S0RqJpqX5XbHg',
	authDomain: 'cocoon-space-preprod-mobile.firebaseapp.com',
	databaseURL:
		'https://cocoon-space-preprod-mobile-default-rtdb.europe-west1.firebasedatabase.app',
	projectId: 'cocoon-space-preprod-mobile',
	storageBucket: 'cocoon-space-preprod-mobile.firebasestorage.app',
	messagingSenderId: '283339168852',
	appId: '1:283339168852:web:e961855af38a698ebaa1c1',
	measurementId: 'G-M4SRR03FEF',
} as const

const configs = {
	development: preprod,
	preprod,
	prod,
} as const

export const getFirebaseConfig = (env: AppEnv = 'prod') =>
	configs[env] ?? configs.prod
